import styled from "styled-components";
import { StyledLink, LinkProps } from "../../../../Link";

export interface MenuLinkProps extends LinkProps {
  level: number;
}
/**
 * The first part of each MenuItem is a menu link that points to a page.
 */
export const MenuLink = styled(StyledLink)<MenuLinkProps>`
  flex-grow: 1;

  text-decoration: none;
  vertical-align: middle;

  color: ${p => p.theme.colors.grey500};

  padding-left: ${(p: { level: number }) => 16 + (p.level - 1) * 24}px;
  &.level-1 {
    font-size: 16px;
    font-weight: 600;
    color: ${p => p.theme.colors.grey600};
  }
`;
